import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Standard } from '../models';
import { AppState } from '../../../../core/reducers';
import { currentUser } from '../../../../core/auth';
import { environment } from '../../../../../environments/environment';
import { QueryParamsModel, QueryResultsModel } from '../../../../core/_base/crud';
import { TransactionType } from '../enums';

@Injectable({ providedIn: 'root' })
export class StandardService {
  private companyId;
  private baseUrl = environment.COMPLIANCE_BASE;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select(currentUser).subscribe((res) => (this.companyId = res.companyID));
  }

  getStandardPage(
    programId: number | '',
    withoutProgram: boolean,
    query: QueryParamsModel,
  ): Observable<QueryResultsModel> {
    const {
      pageSize,
      pageNumber,
      filter: { searchTerm },
      sortField,
      sortOrder,
    } = query;

    const fromString = `program_id=${programId}&without_program=${
      withoutProgram || ''
    }&page=${pageNumber}&size=${pageSize}&search_term=${searchTerm}&sort=${sortField},${sortOrder}`;
    const params = new HttpParams({ fromString });

    return this.http.get<QueryResultsModel>(
      `${this.baseUrl}/companies/${this.companyId}/standards`,
      { params },
    );
  }

  searchStandard(
    programId: number | '',
    withoutProgram: boolean,
    searchTerm = '',
  ): Observable<QueryResultsModel> {
    const query = new QueryParamsModel({ searchTerm }, 'asc', 'standardReference', 0, 20);

    return this.getStandardPage(programId, withoutProgram, query);
  }

  getStandardListByTransaction(
    transactionId: number,
    transactionType: TransactionType,
  ): Observable<Standard[]> {
    const fromString = `transaction_type=${transactionType}`;
    const params = new HttpParams({ fromString });

    return this.http.get<Standard[]>(
      `${this.baseUrl}/companies/${this.companyId}/transactions/${transactionId}`,
      { params },
    );
  }

  setStandardListByTransaction(
    transactionId: number,
    transactionType: TransactionType,
    standardIds: number[],
  ): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/companies/${this.companyId}/transactions`, {
      transaction_id: transactionId,
      transaction_type: transactionType,
      standard_ids: standardIds,
    });
  }

  createStandard(standard: Standard): Observable<HttpResponse<Standard>> {
    return this.http.post<Standard>(
      `${this.baseUrl}/companies/${this.companyId}/standards`,
      standard,
      { observe: 'response' },
    );
  }

  updateStandard(standard: Standard): Observable<HttpResponse<Standard>> {
    return this.http.put<Standard>(
      `${this.baseUrl}/companies/${this.companyId}/standards/${standard.id}`,
      standard,
      { observe: 'response' },
    );
  }

  deleteStandard(standardId: number): Observable<HttpResponse<Standard>> {
    return this.http.delete<Standard>(
      `${this.baseUrl}/companies/${this.companyId}/standards/${standardId}`,
      { observe: 'response' },
    );
  }
}
